import * as d3 from "d3";

export function add(a,b){
    return a+b
}

export function calDistance(x1,y1,x2,y2){
    return Math.sqrt(Math.pow(x1-x2,2)+Math.pow(y1-y2,2))
}

export function getVecNorm(vec){
    let norm=Math.sqrt(Math.pow(vec[0],2)+Math.pow(vec[1],2))
    return norm
}

export function normalizeVec(vec){
    let norm=Math.sqrt(Math.pow(vec[0],2)+Math.pow(vec[1],2))
    let newvec=[vec[0]/norm,vec[1]/norm]
    return newvec
}

export function drawCircle(x,y,r,fill,stroke){
    d3.select("#mainsvg")
        .append("circle")
        .attr("class","elespace")
        .attr("cx",x)
        .attr("cy",y)
        .attr("r",r)
        .attr("fill",fill)
        .attr("stroke",stroke)
        .attr("stroke-width",1)
}

export function drawRect(x,y,width,height,color){
    d3.select("svg")
        .append("rect")
        .attr("x",x-width/2)
        .attr("y",y-height/2)
        .attr("width",width)
        .attr("height",height)
        .attr("fill","none")
        .attr("stroke",color)
        .attr("stroke-width",2)
}

export function drawPolygon(points,dx,dy,color){
    d3.select("svg").append("path")
        .style("fill", "none")
        .style("stroke",color)
        .style("stroke-width", 0.5)
        .attr("d", function () {
            var p = "";
            p += (d3.line()
                    .x(function (dat) {
                        return dat[0]+dx;
                    })
                    .y(function (dat) {
                        return dat[1]+dy;
                    })
            )(points)+ "";
            return p;
        })
        .on('mouseover', function () {
            d3.select(this)
                .style('stroke', "red")
                .style("stroke-width", 2);
        })
        .on('mouseout', function () {
            d3.select(this)
                .style('stroke', "black")
                .style("stroke-width", 0.5);
        });
}
export function drawLine(start,end,color,width){
    d3.select("svg").append("line")
        .attr("x1",start[0])
        .attr("y1",start[1])
        .attr("x2",end[0])
        .attr("y2",end[1])
        .attr("stroke-width",width)
        .attr("stroke",color)
        .on("mouseover",function(){
            d3.select(this)
                .attr("stroke","red")
        })
        .on("mouseout",function(){
            d3.select(this)
                .attr("stroke",color)
        })
}

export function  isContained(catarr,cat){
    catarr=catarr.split(",")
    for(let i=0;i<catarr.length;i++){
        if(catarr[i]==cat){
            return true
        }
    }
    return false
}

export function  PointToSegDist( x,  y,  x1,  y1,  x2,  y2)
{
     let cross = (x2 - x1) * (x - x1) + (y2 - y1) * (y - y1);
    // if (cross <= 0) return Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
    if (cross <= 0) return -1

     let d2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
    // if (cross >= d2) return Math.sqrt((x - x2) * (x - x2) + (y - y2) * (y - y2));
    if (cross >= d2) return -1



    let r = cross / d2;
    let px = x1 + (x2 - x1) * r;
    let py = y1 + (y2 - y1) * r;
    return Math.sqrt((x - px) * (x - px) + (py - y) * (py - y));
}

function calLineCirclePoint(){
    //ax+by+c=0
}

export function calTanPoint(cx,cy,radius,point) {
    //点到圆心的距离
    let d = Math.sqrt(Math.pow(cx - point.x,2) + Math.pow(cy - point.y,2));
    let vc1c2 = {x:point.x - cx,y:-point.y + cy}; //屏幕坐标系与笛卡尔坐标系是y轴是反着的
    let radC1C2 = Math.acos(vc1c2.x / Math.sqrt(Math.pow(vc1c2.x,2) + Math.pow(vc1c2.y,2)));
    let theta = Math.acos(radius/d);
    if(point.y < cy){
        let p1 = {x:cx + Math.cos(theta + radC1C2)*radius,y:cy - Math.sin(theta + radC1C2)*radius};
        let p2 = {x:cx + Math.cos(theta - radC1C2)*radius,y:cy + Math.sin(theta - radC1C2)*radius};
        return {p1:p1,p2:p2};
    }else{
        radC1C2 = Math.PI - radC1C2;
        let p1 = {x:cx + Math.cos(Math.PI - theta - radC1C2)*radius,y:cy + Math.sin(Math.PI - theta - radC1C2)*radius};
        let p2 = {x:cx + Math.cos(Math.PI - (theta - radC1C2))*radius,y:cy - Math.sin(Math.PI - (theta - radC1C2))*radius};
        return {p1:p1,p2:p2};
    }
}

export function calCommonTanPoint(x1,y1,r1,x2,y2,r2){
    let tanPoints=[]
    let delta1=Math.pow(x1-x2,2)+Math.pow(y1-y2,2)-Math.pow(r1+r2,2)//+
    let delta2=Math.pow(x1-x2,2)+Math.pow(y1-y2,2)-Math.pow(r1-r2,2)//-

    let p1=r1*(x2*x2+y2*y2-x1*x2-y1*y2)
    let p2=r2*(x1*x1+y1*y1-x1*x2-y1*y2)
    let q=x1*y2-x2*y1

    //four points
    let vecpq=[x2-x1,y2-y1]
    let normvec=[-vecpq[1],vecpq[0]]
    let dir=normalizeVec(normvec)
    let newpointp=[x1+r1*dir[0],y1+r1*dir[1]]
    let newpointq=[x2+r2*dir[0],y2+r2*dir[1]]

    tanPoints.push([newpointp,newpointq])

    let dir2=[-1*dir[0],-1*dir[1]]
    let newpointp2=[x1+r1*dir2[0],y1+r1*dir2[1]]
    let newpointq2=[x2+r2*dir2[0],y2+r2*dir2[1]]

    tanPoints.push([newpointp2,newpointq2])


    if(delta1<0&&delta2<0){
        return []
    }
    else if(delta1<0&&delta2>0){
        //相交, just four points, two lines
        return tanPoints
    }
    else if(delta1==0&&delta2>0){
        //外切, five points, two lines
        return tanPoints

    }
    else if(delta1>0&&delta2>0){
        //外离, eight points, four lines
        let intersecx=(r1*x2+r2*x1)/(r1+r2)
        let intersecy=(r1*y2+r2*y1)/(r1+r2)
        let tanpoints1=calTanPoint(x1,y1,r1,{x:intersecx,y:intersecy})
        let tanpoints2=calTanPoint(x2,y2,r2,{x:intersecx,y:intersecy})

        let p1=tanpoints1.p1
        let p2={x:intersecx,y:intersecy}
        let p3=tanpoints2.p1

        let delta=(p3.y-p1.y)*(p2.x-p1.x)-(p2.y-p1.y)*(p3.x-p1.x)
        if(Math.abs(delta)<=0.000001){
            //p1p1
            tanPoints.push([[tanpoints1.p1.x,tanpoints1.p1.y],[tanpoints2.p1.x,tanpoints2.p1.y]])
            tanPoints.push([[tanpoints1.p2.x,tanpoints1.p2.y],[tanpoints2.p2.x,tanpoints2.p2.y]])

        }
    else{
        //p1p2
            tanPoints.push([[tanpoints1.p1.x,tanpoints1.p1.y],[tanpoints2.p2.x,tanpoints2.p2.y]])
            tanPoints.push([[tanpoints1.p2.x,tanpoints1.p2.y],[tanpoints2.p1.x,tanpoints2.p1.y]])
        }

    return tanPoints

    }

    else{
        return []
    }


}




export function drawArc(startp,endp,center,radius){
    let pathstr=""
    pathstr+="M "+startp[0]+","+startp[1]
    let largearcflag=0
    let vec1=[startp[0]-center[0],startp[1]-center[1]]

    let vec2=[endp[0]-center[0],endp[1]-center[1]]
    let crossmul=vec1[0]*vec2[1]-vec2[0]*vec1[1]
    if(crossmul>0){
        largearcflag=1
    }
    else if(crossmul<=0){
        largearcflag=0
    }
    pathstr+=" A "+radius+","+radius+" 0 "+largearcflag+" ,0 "+(endp[0])+","+(endp[1])
    d3.select("svg")
        .append("path")
        .attr("d",pathstr)
        .attr("fill","none")
        .attr("stroke","black")
        .attr("stroke-width","1")
}

export function getDegreeTwoVec(vec1,vec2){
    let norm1=getVecNorm(vec1)
    let norm2=getVecNorm(vec2)
    let dot=vec1[0]*vec2[0]+vec1[1]*vec2[1]

    let cos=dot/(norm1*norm2)

    return Math.acos(cos)

}

export function rotatePoint(x,y,rx0,ry0,alpha){
    let x0= (x - rx0)*Math.cos(alpha) - (y - ry0)*Math.sin(alpha) + rx0 ;
    let y0= (x - rx0)*Math.sin(alpha) + (y - ry0)*Math.cos(alpha) + ry0 ;
    return [x0,y0]
}

export function crossMul(vec1,vec2){

    return vec1[0]*vec2[1]-vec2[0]*vec1[1]
}

export function clone(obj) {
    // Handle the 3 simple types, and null or undefined or function
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        var copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array or Object
    if (obj instanceof Array | obj instanceof Object) {
        var copy = (obj instanceof Array)?[]:{};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                copy[attr] = clone(obj[attr]);
        }
        return copy;
    }
    throw new Error("Unable to clone obj! Its type isn't supported.");
}